import React from 'react'
import styles from './SidebarShell.module.scss'

interface SidebarShellProps {
  children: React.ReactNode
  open?: boolean
  className?: never
}

export const SidebarShell: React.FC<SidebarShellProps> = ({ children, open = false }) => (
  <aside className={[styles.sidebar, open ? styles.open : ''].filter(Boolean).join(' ')}>
    {children}
  </aside>
)
